<template>
    <app-layout title="Rozepsané zprávy">

        <MessagesTable v-if="messages.length > 0" type="drafts" :messages="messages" @refreshMessages="refreshMessages"/>

        <MessagesTableNoMessages v-else/>

        <p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>

    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import { useToast } from "vue-toastification";
import MessagesTable from "../Components/MessagesTable";
import MessagesTableNoMessages from "../Components/MessagesTableNoMessages";

export default {
    components: {
        MessagesTableNoMessages,
        MessagesTable,
        AppLayout,
    },
    data() {
        return {
            messages: this.$page.props.messages,
            page: this.$page.props.page,
            search: this.$page.props.search,
            maxPage: this.$page.props.maxPage,

            showMessageOptions: null
        }
    },
    setup(){
        const toast = useToast();
        return { toast }
    },
    updated(){
    },
    created(){
    },
    destroyed(){
    },
    mounted(){
        this.setUpEcho();
    },
    unmounted(){
        this.destroyEcho();
    },

    methods: {
        setUpEcho(){
            console.log('stup up echo drafts')
            Echo.private('App.Models.User.' + this.$page.props.user.id)
                .listen('MessagesChanged', (e) => {
                    console.log('MessagesChanged', e);
                    this.refreshMessages();
                })
        },
        destroyEcho(){
            console.log('destroy up echo drafts')
            Echo.leave('App.Models.User.'+this.$page.props.user.id);
        },
        refreshMessages(){
            axios.get(route('fapi.getdrafts', {page:this.page, search: this.search}))
                .then(response => {
                    if(response.status === 200) {
                        this.messages = response.data.messages;
                        this.page = response.data.page;
                        this.maxPage = response.data.maxPage;
                    }
                });
        },
    }
}
</script>

